'use strict';
import React, { PureComponent } from 'react';
import { createForm } from 'rc-form';
import MotivoAjuste from './Formulario/MotivoAjuste';
import CreditoDebito from './Formulario/CreditoDebito';
import PeriodoActual from './Formulario/PeriodoActual';
import Moneda from './Formulario/Moneda';
import ImporteSinIva from './Formulario/ImporteSinIva';
import Iva from './Formulario/Iva';
import ImporteTotal from './Formulario/ImporteTotal';
import CantidadCuotas from './Formulario/CantidadCuotas';
import FechaValor from './Formulario/FechaValor';
import Referencia from './Formulario/Referencia';
import AjusteCargoRdButton from './Formulario/AjusteCargoRdButton'


class Formulario extends PureComponent {

    constructor(props) {
        super(props);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleSubmit(e) {
        e.preventDefault();
        const { parametroGeneral, form, ingresoAjuste, actions, cuenta } = this.props;
        form.validateFields((err, fieldsValue) => {
            let ajuste, AjusteCargoEstadoId, importeConIva, importeSinIva, importeIva, loginUsuario, debitoCreditoEdicion;
            let debitoCreditoAlta = null;
            

            // ingresoAjuste.ajusteCargoRdButton 1 = cargo / 0 = ajuste
            AjusteCargoEstadoId = ingresoAjuste && parametroGeneral && ingresoAjuste.ajusteCargoRdButton ? parametroGeneral.SINOCONFIRMACIONCARGOS : parametroGeneral.SINOCONFIRMACIONAJUSTES;
            AjusteCargoEstadoId = AjusteCargoEstadoId ? 1 : 2;

            //obtengo el login del usuario
            loginUsuario = ingresoAjuste && ingresoAjuste.executionContext && ingresoAjuste.executionContext.login
                ? ingresoAjuste.executionContext.login : "";

            //Mando 1 - Credito o 0 - Debito dependiendo del valor que haya en ingresoAjuste.motivoAjusteDataFiltrado.DebitoCredito (2 débito, 1 crédito)
            //Si viene ingresoAjuste.motivoAjusteDataFiltrado.TipoMovimiento con dato es porque es camino de edición
            //Se utiliza el mismo objeto ingresoAjuste.motivoAjusteDataFiltrado tanto para carga de combo Motivo Ajuste como para data de registro de Grilla para Edición.
            if (ingresoAjuste.motivoAjusteDataFiltrado && ingresoAjuste.motivoAjusteDataFiltrado.TipoMovimiento) {
                debitoCreditoEdicion = ingresoAjuste.datosEdicion.DebitoCredito;
            }
            else {
                debitoCreditoEdicion = ingresoAjuste.motivoAjusteDataFiltrado && ingresoAjuste.motivoAjusteDataFiltrado.DebitoCredito ? ingresoAjuste.motivoAjusteDataFiltrado.DebitoCredito : ingresoAjuste.debitoCredito;
            }
            //Si ingresoAjuste.motivoAjusteDataFiltrado.DebitoCredito == 0 -> El usuario seleccionó por su cuenta entre Credito y debito
            //El mismo se guardara en la variable ingresoAjuste.debitoCredito
            //Si ingresoAjuste.motivoAjusteDataFiltrado.DebitoCredito != 0 -> Se le asignará el que venga por BD y no será modificable
            if (ingresoAjuste && ingresoAjuste.motivoAjusteDataFiltrado && ingresoAjuste.motivoAjusteDataFiltrado.DebitoCredito != 0) {
                debitoCreditoAlta = ingresoAjuste.motivoAjusteDataFiltrado.DebitoCredito;
            } else {
                debitoCreditoAlta = ingresoAjuste.debitoCredito;
            }

            //https://bancar.atlassian.net/browse/ADT-1777 Importe sin Iva, si es CARGO y CREDITO multiplicar x -1
            importeSinIva = ingresoAjuste && debitoCreditoAlta == 2 && ingresoAjuste.ajusteCargoRdButton //OK
                ? (ingresoAjuste.importeSinIva * -1) : ingresoAjuste.importeSinIva;
             importeSinIva = parseFloat(importeSinIva);

            //https://bancar.atlassian.net/browse/ADT-1777 Importe Iva, si es CARGO y CREDITO multiplicar x -1
            importeIva = ingresoAjuste && ingresoAjuste.motivoAjusteDataFiltrado && ingresoAjuste.motivoAjusteDataFiltrado.PermiteIva && debitoCreditoAlta == 2 && ingresoAjuste.ajusteCargoRdButton //OK
                ? (importeSinIva / 100 * ingresoAjuste.motivoAjusteDataFiltrado.MontoIva * 1) 
                : ingresoAjuste && ingresoAjuste.motivoAjusteDataFiltrado && ingresoAjuste.motivoAjusteDataFiltrado.PermiteIva ? (importeSinIva / 100 * ingresoAjuste.motivoAjusteDataFiltrado.MontoIva) : 0 ;
            importeIva = parseFloat(importeIva);

            //https://bancar.atlassian.net/browse/ADT-1777 Importe Iva, si es CARGO y CREDITO multiplicar x -1
            // importeConIva = ingresoAjuste && debitoCreditoAlta == 2 && ingresoAjuste.ajusteCargoRdButton //OK
            //     ? ((importeIva + importeSinIva)) : (importeIva + importeSinIva);
            importeConIva = importeIva + importeSinIva;

            //Conversion Edicion
            if (ingresoAjuste.motivoAjusteDataFiltrado && ingresoAjuste.motivoAjusteDataFiltrado.TipoMovimiento) {
                

            //https://bancar.atlassian.net/browse/ADT-1777 Importe sin Iva, si es CARGO y CREDITO multiplicar x -1
            importeSinIva = ingresoAjuste && debitoCreditoEdicion == 1 && ingresoAjuste.ajusteCargoRdButton //OK
                ? (ingresoAjuste.importeSinIva * -1) : ingresoAjuste.importeSinIva;
             importeSinIva = parseFloat(importeSinIva);

            //https://bancar.atlassian.net/browse/ADT-1777 Importe Iva, si es CARGO y CREDITO multiplicar x -1
            importeIva = ingresoAjuste && ingresoAjuste.motivoAjusteDataFiltrado && ingresoAjuste.motivoAjusteEdicion[0].PermiteIva && debitoCreditoEdicion == 1 && ingresoAjuste.ajusteCargoRdButton //OK
                ? (importeSinIva / 100 * ingresoAjuste.motivoAjusteEdicion[0].MontoIva * 1) 
                : ingresoAjuste.motivoAjusteEdicion[0].PermiteIva ? (importeSinIva / 100 * ingresoAjuste.motivoAjusteEdicion[0].MontoIva) : 0 ;
            importeIva = parseFloat(importeIva);

            //https://bancar.atlassian.net/browse/ADT-1777 Importe Iva, si es CARGO y CREDITO multiplicar x -1
            // importeConIva = ingresoAjuste && debitoCreditoAlta == 2 && ingresoAjuste.ajusteCargoRdButton //OK
            //     ? ((importeIva + importeSinIva)) : (importeIva + importeSinIva);

            importeConIva = importeIva + importeSinIva;


            switch (debitoCreditoEdicion) {
                case 0:
                    debitoCreditoEdicion = 1;
                    break;
                case 1:
                    debitoCreditoEdicion = 2;
                default:
                    break;
            }
            }
            if(ingresoAjuste.errorImporteSinIva){
                importeConIva = importeIva;
                importeSinIva = undefined;
            } else {
                importeConIva = importeIva + importeSinIva;
            }
            
            if (ingresoAjuste.accion == "guardar") {
                ajuste = {
                    AjusteCargoId: ingresoAjuste.motivoAjusteDataFiltrado ? ingresoAjuste.motivoAjusteDataFiltrado.IdMotivo : null,
                    AjusteCargoEstadoId: AjusteCargoEstadoId,
                    SucursalId: ingresoAjuste.motivoAjusteDataFiltrado ? ingresoAjuste.sucursalId : null,
                    FechaPresentacion: ingresoAjuste.fechaValor,
                    AjusteMonedaId: ingresoAjuste.motivoAjusteDataFiltrado ? ingresoAjuste.motivoAjusteDataFiltrado.MonedaId : null,
                    ImporteSinIva: importeSinIva,
                    ImporteIVA: importeIva,
                    DebitoCredito: debitoCreditoAlta,
                    Importe: importeConIva,
                    CantidadCuotas: 1,
                    UsuarioAlta: loginUsuario,
                    UsuarioConfirmacion: AjusteCargoEstadoId ? null : loginUsuario,
                    FechaConfirmacion: AjusteCargoEstadoId ? null : new Date(),
                    Referencia: ingresoAjuste.referencia,
                    TipoOperacion: 2,
                    TipoMovimiento: ingresoAjuste && ingresoAjuste.ajusteCargoRdButton ? "C" : "A",
                    IndicadorAjusteCargo: ingresoAjuste && ingresoAjuste.ajusteCargoRdButton ? 1 : 0 //0-Ajuste 1-Cargo
                };
            }
            else {
                ajuste = {
                    AjusteCargoId: ingresoAjuste.datosEdicion.Id,
                    AjusteMotivoId: ingresoAjuste.motivoAjusteDataFiltrado.MotivoId ? ingresoAjuste.motivoAjusteDataFiltrado.MotivoId : ingresoAjuste.motivoAjusteDataFiltrado.IdMotivo,
                    AjusteMonedaId: ingresoAjuste.motivoAjusteDataFiltrado.MonedaId,
                    ImporteSinIva: importeSinIva,
                    ImporteIVAAjuste: importeIva,
                    DebitoCredito: ingresoAjuste.debitoCredito ? ingresoAjuste.debitoCredito : debitoCreditoEdicion,
                    Importe: importeConIva,
                    UsuarioModificacion: loginUsuario,
                    Referencia: ingresoAjuste.referencia,
                    TipoMovimiento: ingresoAjuste && ingresoAjuste.ajusteCargoRdButton ? 1 : 0
                };
            }

            actions.aceptar(ajuste, ingresoAjuste.accion, form.resetFields, err, cuenta, ingresoAjuste.ajusteEstados, ingresoAjuste.cargoEstados, loginUsuario);
        });
    }

    render() {
        const { ingresoAjuste, actions } = this.props;
        let permisoAlta = ingresoAjuste && ingresoAjuste.permisos ? false : true;
        let ajusteEdicion = ingresoAjuste.ajusteEdicion;

        let ajusteCargoRdButton = ingresoAjuste.ajusteCargoRdButton;

        if (ajusteEdicion) {
            ajusteCargoRdButton = ajusteEdicion.TipoMovimiento == "A" ? 0 : 1;
        }

        return (
            <form onSubmit={this.handleSubmit} id="frmCobranza" name="Formulario" className="" method="POST">
                <div className="row top-separator-xs">

                    <div className="col-xs-12">
                        <h3>Ingresar ajustes y cargos</h3>
                        <AjusteCargoRdButton form={this.props.form} selectRadioIngresoAjustes={actions.selectRadioIngresoAjustes} ajusteCargoRdButton={ajusteCargoRdButton} permisos={ingresoAjuste.permisos} />
                        <MotivoAjuste form={this.props.form} ingresoAjuste={ingresoAjuste} seleccionarMotivo={actions.seleccionarMotivo} permisos={ingresoAjuste.permisos} />
                        <CreditoDebito ingresoAjuste={ingresoAjuste} selectRadioIngresoAjustes={actions.selectRadioIngresoAjustes} permisos={ingresoAjuste.permisos} />
                        <PeriodoActual ingresoAjuste={ingresoAjuste} form={this.props.form} permisos={ingresoAjuste.permisos} />
                        <Moneda ingresoAjuste={ingresoAjuste} actions={actions} permisos={ingresoAjuste.permisos} />
                        <ImporteSinIva form={this.props.form} ingresoAjuste={ingresoAjuste} cambiarImporteConIva={actions.cambiarImporteConIva} permisos={ingresoAjuste.permisos} />
                        <Iva ingresoAjuste={ingresoAjuste} permisos={ingresoAjuste.permisos} />
                        <ImporteTotal importes={ingresoAjuste} permisos={ingresoAjuste.permisos} />
                        <CantidadCuotas form={this.props.form} ingresoAjuste={ingresoAjuste} changeCuotas={actions.changeCuotas} permisos={ingresoAjuste.permisos} />
                        <FechaValor form={this.props.form} ingresoAjuste={ingresoAjuste} permisos={ingresoAjuste.permisos} />
                        <Referencia form={this.props.form} actualizaReferencia={actions.actualizaReferencia} ingresoAjuste={ingresoAjuste} permisos={ingresoAjuste.permisos} />
                        <div className="row top-separator-xs">
                            <div className="col-xs-1">
                                <button type="button" disabled={permisoAlta} className="botonCancelarAjusteCargo" onClick={() => this.props.actions.openModalAjustesCargos(true, this.props.form.resetFields, false, false)}>Cancelar</button>
                            </div>
                            <div className="col-xs-3" style={{ marginLeft: "89px" }}>
                                <button type="submit" disabled={permisoAlta} className="botonAceptarAjusteCargo">Aceptar</button>
                            </div>
                        </div>

                    </div>
                </div >
            </form>
        )
    }
}

export default createForm()(Formulario);